import { useEffect, useState } from 'react';
import { FiMenu, FiMoon, FiSun, FiX } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import { useSiteProfile } from '../../../Portfolio/ProfileContext';
import s from './Header.module.css';

const Header = () => {
    const { t, i18n } = useTranslation();
    const profile = useSiteProfile();
    const [open, setOpen] = useState(false);
    const [theme, setTheme] = useState(() => localStorage.getItem('site-theme') || 'light');
    const language = i18n.resolvedLanguage?.startsWith('zh') ? 'zh' : 'en';
    const links = [
        { to: '/', label: t('nav.home'), end: true },
        { to: '/projects', label: t('nav.projects') },
        { to: '/writing', label: t('nav.writing') },
        { to: '/about', label: t('nav.about') },
    ];

    useEffect(() => {
        document.documentElement.dataset.theme = theme;
        localStorage.setItem('site-theme', theme);
    }, [theme]);

    useEffect(() => {
        document.documentElement.lang = language === 'zh' ? 'zh-CN' : 'en';
        localStorage.setItem('site-language', language);
    }, [language]);
    return (
        <header className={s.header}>
            <nav className={s.nav} aria-label="Primary navigation">
                <Link to="/" className={s.brand} onClick={() => setOpen(false)}>
                    <span className={s.brandMark} aria-hidden="true">C<span>.</span></span>
                    <span className={s.brandCopy}>
                        <strong>CodeCognition</strong>
                        <small>by {profile.displayName}</small>
                    </span>
                </Link>

                <button
                    className={s.menuButton}
                    type="button"
                    aria-label={open ? 'Close navigation' : 'Open navigation'}
                    aria-expanded={open}
                    onClick={() => setOpen((value) => !value)}
                >
                    {open ? <FiX /> : <FiMenu />}
                </button>

                <div className={`${s.navPanel} ${open ? s.navPanelOpen : ''}`}>
                    <div className={s.navLinks}>
                        {links.map(({ to, label, end }) => (
                            <NavLink key={to} to={to} end={end} onClick={() => setOpen(false)} className={({ isActive }) => isActive ? s.active : undefined}>
                                {label}
                            </NavLink>
                        ))}
                    </div>
                    <div className={s.navActions}>
                        <button
                            className={s.languageButton}
                            type="button"
                            aria-label={t('language.switch')}
                            onClick={() => i18n.changeLanguage(language === 'zh' ? 'en' : 'zh')}
                        >
                            {language === 'zh' ? 'EN' : '中文'}
                        </button>
                        <button
                            className={s.themeButton}
                            type="button"
                            aria-label={t(theme === 'light' ? 'theme.dark' : 'theme.light')}
                            onClick={() => setTheme((value) => value === 'light' ? 'dark' : 'light')}
                        >
                            {theme === 'light' ? <FiMoon /> : <FiSun />}
                        </button>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
